module.exports = __webpack_public_path__ + "img/GrantsConstraintsPlansSlidesDetails.598a96c3.svg";